import { takeLatest, put, delay } from 'redux-saga/effects';


import * as TYPES from '../actions/types';
import {  loaderAction,  saveClientDiagnosis} from '../actions';
import { GenericResponseModel } from '../../dataModel/authModels';
import { dX } from '../../services/diagnosis';



export function* getDiagnosisSaga() {
  try {
    yield takeLatest(TYPES.GET_CLIENT_DIAGNOSIS, getDianosisWorker);
  } catch (err) {
  }
}

function* getDianosisWorker(param:any) {
  try {
    yield put(loaderAction(true));
    const response: GenericResponseModel = yield dX.getDxList(param['payload']);
    yield put(saveClientDiagnosis(response.resultData));
    yield put(loaderAction(false));
  }catch(e){
  }
}


